import axios from 'axios';

// Tiny stale-while-revalidate cache for GET requests.
// ONLY use it for data that rarely changes and carries no stock/price/status (e.g. platform names).
// Never use it for sales, returns, purchases or products - those must always be fetched fresh.
// Cached data is handed to onData immediately, then fresh data is fetched and handed over again.
const cache = new Map();

const keyFor = (url, params) => `${url}?${params ? JSON.stringify(params) : ''}`;

export const hasCached = (url, params) => cache.has(keyFor(url, params));

export const clearCache = () => cache.clear();

export const getWithCache = async (url, { params, onData, useCached = true } = {}) => {
  const key = keyFor(url, params);
  if (useCached && onData && cache.has(key)) {
    onData(cache.get(key));
  }
  const response = await axios.get(url, params ? { params } : undefined);
  cache.set(key, response.data);
  if (onData) onData(response.data);
  return response.data;
};
